<template>
  <div class="card-footer d-flex align-items-center justify-content-between" v-if="pages">
    <div>
      <ul class="pagination pagination-sm" v-if="pages > 1">
        <li class="page-item"
            :class="{'disabled': !isPreviousPageAvailable}">
          <a class="page-link"
             :disabled="!isPreviousPageAvailable"
             href
             @click.prevent="goToFirstPage()">
            Pierwsza
          </a>
        </li>
        <li class="page-item"
            :class="{'disabled': !isPreviousPageAvailable}">
          <a class="page-link"
             :disabled="!isPreviousPageAvailable"
             href
             @click.prevent="goToPreviousPage()">
            Poprzednia
          </a>
        </li>
        <li class="page-item"
            :class="{'disabled': !isNextPageAvailable}">
          <a class="page-link"
             :disabled="!isNextPageAvailable"
             href
             @click.prevent="goToNextPage()">
            Następna
          </a>
        </li>
        <li class="page-item"
            :class="{'disabled': !isNextPageAvailable}">
          <a class="page-link"
             :disabled="!isNextPageAvailable"
             href
             @click.prevent="goToLastPage()">
            Ostatnia
          </a>
        </li>
      </ul>
    </div>
    <div class="text-muted">
      Strona {{ currentPage }} z {{ pages }}
    </div>
  </div>
</template>

<script>
  export default {
    props: ['paramsName', 'totalCount'],
    computed: {
      paramsState() {
        return this.$store.state[this.paramsName];
      },
      pages() {
        return Math.ceil(this.totalCount / this.paramsState.pageSize);
      },
      currentPage() {
        return 1 + (this.paramsState.offset / this.paramsState.pageSize);
      },
      isNextPageAvailable() {
        return (this.paramsState.offset + this.paramsState.pageSize) < this.totalCount;
      },
      isPreviousPageAvailable() {
        return this.paramsState.offset >= this.paramsState.pageSize;
      },
    },
    methods: {
      changePage(offset) {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: { offset },
        });
        this.$emit('reload');
      },
      goToPreviousPage() {
        if (this.isPreviousPageAvailable) {
          const offset = this.paramsState.offset - this.paramsState.pageSize;
          this.changePage(offset);
        }
      },
      goToNextPage() {
        if (this.isNextPageAvailable) {
          const offset = this.paramsState.offset + this.paramsState.pageSize;
          this.changePage(offset);
        }
      },
      goToFirstPage() {
        if (this.isPreviousPageAvailable) {
          const offset = 0;
          this.changePage(offset);
        }
      },
      goToLastPage() {
        if (this.isNextPageAvailable) {
          const offset = (this.pages - 1) * this.paramsState.pageSize;
          this.changePage(offset);
        }
      },
    },
  };
</script>
